<script setup lang="ts" name="DataTableNoResults">
defineProps<{
  overflowAreaWidth: number | null;
  noResultsText: string;
}>();
</script>

<template>
  <div
    class="flex-center sticky left-0 col-span-full"
    :style="{ width: `${overflowAreaWidth}px` }"
  >
    <p class="flex-center h-36 text-sm text-charcoal-6">
      {{ noResultsText }}
    </p>
  </div>
</template>
